/**
 * @file KeyedCollection
 * @author Wim Haanstra
 * A generic dictionary object, that kan be used for KV's
 */
var KeyedCollection = /** @class */ (function () {
    function KeyedCollection() {
        this._items = {};
        this._count = 0;
    }
    KeyedCollection.prototype.ContainsKey = function (key) {
        return this._items.hasOwnProperty(key);
    };
    KeyedCollection.prototype.Count = function () {
        return this._count;
    };
    KeyedCollection.prototype.Add = function (key, value) {
        var hasProperty = this.ContainsKey(key);
        this._items[key] = value;
        if (!hasProperty) {
            this._count += 1;
        }
        return value;
    };
    KeyedCollection.prototype.Clear = function () {
        this._items = {};
        this._count = 0;
    };
    KeyedCollection.prototype.Remove = function (key) {
        if (this.ContainsKey(key)) {
            var value = this._items[key];
            delete this._items[key];
            this._count -= 1;
            return value;
        }
        else {
            return null;
        }
    };
    KeyedCollection.prototype.Item = function (key) {
        return this._items[key];
    };
    Object.defineProperty(KeyedCollection.prototype, "Keys", {
        get: function () {
            var _this = this;
            var result = [];
            Object.keys(this._items).forEach(function (key) {
                if (_this._items.hasOwnProperty(key)) {
                    result.push(key);
                }
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyedCollection.prototype, "Values", {
        get: function () {
            var _this = this;
            var result = [];
            Object.keys(this._items).forEach(function (key) {
                if (_this._items.hasOwnProperty(key)) {
                    result.push(_this._items[key]);
                }
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    return KeyedCollection;
}());
export { KeyedCollection };
